<template>
  <Header :address="address" :loginLoading="loginLoading" @connectWallet="connectWallet" @disconnectWallet="disconnectWallet" />
  <main class="pb-2">
    <router-view :address="address" :loginLoading="loginLoading" @connectWallet="connectWallet"></router-view>
  </main>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// import Web3 from 'web3';

import Header from './components/Header';
import { connectWithLogin } from './services/helper/connectWithLogin';
import { getDefaultAvatar } from './services/helper/getDefaultAvatar';
import { geturlParamsByName } from './utils/url';
import { getWeb3 } from './services/helper/utils';
import ChainApi from './services/wallet/ChainApi';

export default {
  name: 'App',

  components: {
    Header
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const address = ref(null);
    const loginLoading = ref(false);

    const chainApi = ChainApi;

    let ethereum = window.ethereum;

    const initPage = () => {
      if(route.meta && route.meta.title) {
        document.title = route.meta.title + ' - SUPER AVATAR';
      }
      else {
        document.title = "SUPER AVATAR";
      }
    };

    const connectWallet = async(to = null) => {
      if(loginLoading.value) {
        return;
      }
      loginLoading.value = true;
      /*
      let switchRes = false;
      if(ethereum) {
        let tempEth = window.ethereum;
        if(window.ethereum.providers && window.ethereum.providers.length) {
          window.ethereum.providers.forEach(provider => {
              if(provider.isMetaMask) {
                tempEth = provider;
              }
          });
        }

        let web3 = new Web3(tempEth);
        let tempCid = await web3.eth.getChainId();

        let incorrectChain = (process.env.VUE_APP_ENV == 'dev' ? (tempCid != 97) : (tempCid != 56));

        if(incorrectChain) {
          try{
            await web3.currentProvider.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: process.env.VUE_APP_ENV == 'dev' ? web3.utils.toHex(97) : web3.utils.toHex(56) }]
            });
            switchRes = true;
          }
          catch {
            switchRes = false;
          }
          if(switchRes) {
            await new Promise(resolve => setTimeout(resolve, 300));
          }
        }
        else {
          switchRes = true;
        }
        if(!switchRes) {
          loginLoading.value = false;
          return;
        }
      }
      */

      let res = await connectWithLogin();
      if(res) {
        await getDefaultAvatar(res);
        address.value = res;

        //let tempSid = await resolveSpaceIdByAddress(res);
        //sessionStorage.setItem('superAvatarSpaceId', tempSid);

        if(to) {
          loginLoading.value = false;
          router.push(to);
        }
      }
      loginLoading.value = false;
    }

    const disconnectWallet = () => {
      address.value = null;

      sessionStorage.removeItem('superAvatarSymbol');
      sessionStorage.removeItem('superAvatarBalance');
      sessionStorage.removeItem('superAvatarToken');
      sessionStorage.removeItem('superAvatarAuthToken');
      sessionStorage.removeItem('superAvatarAccount');
      sessionStorage.removeItem('superAvatarSpaceId');

      localStorage.removeItem("walletconnect");

      chainApi.chainWeb3.disconnect();
      verifyAuth();
    }

    const verifyAuth = () => {
      if(route.path != '/' && route.path.toUpperCase() != '/CAMPAIGN' && !sessionStorage.getItem('superAvatarAuthToken')) {
        console.log('redirect to home')
        router.push('/');
      }
    }

    onMounted(() => {
      setTimeout(() => {
        verifyAuth();
        initPage();

        if(window.ethereum && window.ethereum.providers && window.ethereum.providers.length) {
          window.ethereum.providers.forEach(provider => {
            if(provider.isMetaMask) {
              ethereum = provider;
            }
          });
        }

        if(sessionStorage.getItem('superAvatarAuthToken') && sessionStorage.getItem('superAvatarAccount')) {
          connectWallet();
        }
        else {
          disconnectWallet();
        }

        let referralCode = geturlParamsByName('REFERRALCODE') || geturlParamsByName('referralcode') || geturlParamsByName('referralCode');
        if(sessionStorage.getItem('superAvatarReferralCode') && !referralCode) {
          referralCode = sessionStorage.getItem('superAvatarReferralCode');
        }
        sessionStorage.setItem('superAvatarReferralCode', referralCode);

      }, 100);
    });

    watch(() => route.path, () => {
      window.scroll(0, 0);

      verifyAuth();
      initPage();
    });

    return {
      address,
      loginLoading,
      connectWallet,
      disconnectWallet,
    }
  }
}
</script>

<style>
body {
  min-height: 100vh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-image: url('./assets/images/bg.jpg');
}

.common-container {
  min-height: 85vh;
  padding-top: 20px;
  padding-bottom: 30px;
}

@media (max-width: 1000px) {
 
}
</style>
